<template>
  <div id="app" class="page-wrapper">
    <Navbar/>
    <router-view/>
  </div>
</template>

<script>

import Navbar from "./components/Shared/Navbar";

export default {
  name: 'app',
  components: {
    Navbar,
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
#app {
  font-family: Open Sans;
  -webkit-font-smoothing: antialiased;
  background-color: #FFFFFF;
}
html {
    overflow: hidden;
    height: 100%;
}

body {
    height: 100%;
    overflow: auto;
}
.grey {
  background-color: #f6f5fb;
}

.light-grey {
  background-color: #f7f8fc;
}

.demo-button {
  margin: 47px 0;
  border: none;
  border-radius: 100px;
  padding: 1em 2em;
  font-style: normal;
  font-size: 20px;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  text-transform: uppercase;
  width: 225px;
  justify-content: center;
  outline: none !important;  
  &.aqua {
    background-color: #36C2CF;
    color: #FFFFFF;
  }
  &.blue {
    background-color: #5473E8;
    color: #FFFFFF;
  }
}
</style>
